<pg-header
  title="Territorial Units"
  ticon="folder"
  bckbtn="true"
  bckurl="/setup"
></pg-header>

@if ((user.permissions.slct_in==1)?true:false) {
<div nz-row class="gridTop">
  @if (loader) {
  <ds-loading></ds-loading>
  }
  <div class="ds-card grid">
    <app-data-grid
      id="gridContainer"
      style="width: 100%"
      [dataSource]="gridData"
      [legacyColumns]="columnDefs"
      [searchPanel]="true"
      [filterRow]="true"
      [filterPanel]="true"
      [groupPanel]="true"
      [columnChooser]="true"
      [allowExport]="user.permissions.exprt_in == 1 ? true : false"
      exportFileName="territorial units List"
      [pageSize]="10"
      [allowedPageSizes]="[10, 25, 50, 100]"
      [showPageSizeSelector]="true"
      [rowAlternationEnabled]="true"
      [showBorders]="true"
    >
      <app-grid-column
        [showInColumnChooser]="false"
        type="buttons"
        [visible]="user.permissions.dlte_in == 1 ? true : false"
        [width]="100"
        caption="Edit"
        cellTemplate="editTemplate"
      ></app-grid-column>
      <ng-template appGridCell="editTemplate" let-data="cell"
        ><div>
          <div class="tblEdtBtn" (click)="onEdit2(data)">Edit</div>
        </div></ng-template
      >
      <app-grid-column
        [showInColumnChooser]="false"
        [visible]="user.permissions.dlte_in == 1 ? true : false"
        type="buttons"
        [width]="100"
        caption="Delete"
        cellTemplate="delTemplate"
      ></app-grid-column>
      <ng-template appGridCell="delTemplate" let-data="cell"
        ><div>
          <div class="tblDelBtn" (click)="onDelete2(data)">Delete</div>
        </div></ng-template
      >
    </app-data-grid>
  </div>
  @if ((user.permissions.slct_in==1)?false:true) {
  <div class="permMsg">{{ mainMessage }}</div>
  }
</div>
}

<nz-drawer
  [nzBodyStyle]="{
    height: 'calc(100% - 55px)',
    overflow: 'auto',
    'padding-bottom': '53px'
  }"
  [nzMaskClosable]="false"
  [nzWidth]="370"
  [nzVisible]="shwSidebar"
  [nzTitle]="sidebarHeading"
  (nzOnClose)="closeSideBar()"
>
  <form nz-form [formGroup]="blockForm">
    <div class="input-row" nz-row>
      <div
        nz-col
        nzXs="24"
        nzSm="24"
        nzMd="24"
        nzLg="24"
        nzXl="24"
        class="blksMrgn"
      >
        <div class="inptLbl">District</div>
        <nz-select
          nzShowSearch
          nzAllowClear
          style="width: 100%"
          nzPlaceHolder="Select Districts"
          formControlName="dstrct_id"
          (ngModelChange)="getulbs($event)"
        >
          @for (d of dstrctsLst; track d) {
          <nz-option [nzValue]="d.dstrt_id" [nzLabel]="d.dstrt_nm"> </nz-option>
          }
        </nz-select>
      </div>
      <div
        nz-col
        nzXs="24"
        nzSm="24"
        nzMd="24"
        nzLg="24"
        nzXl="24"
        class="blksMrgn"
      >
        <div class="inptLbl">Urban/Rural</div>
        <nz-select
          style="width: 100%"
          nzPlaceHolder="Select"
          formControlName="urbn_in"
        >
          @for (a of area; track a) {
          <nz-option [nzLabel]="a.area_nm" [nzValue]="a.id"> </nz-option>
          }
        </nz-select>
      </div>
    </div>

    <div class="input-row" nz-row>
      <div
        nz-col
        nzXs="24"
        nzSm="24"
        nzMd="24"
        nzLg="24"
        nzXl="24"
        class="blksMrgn"
      >
        <div class="inptLbl">ULB</div>
        <nz-select
          nzShowSearch
          nzAllowClear
          style="width: 100%"
          nzPlaceHolder="Select ULB"
          formControlName="ulb_id"
          (ngModelChange)="getscvlym()"
        >
          @for (u of ulbLst; track u) {
          <nz-option [nzValue]="u.ulb_id" [nzLabel]="u.ulb_nm"> </nz-option>
          }
        </nz-select>
      </div>
      <div
        nz-col
        nzXs="24"
        nzSm="24"
        nzMd="24"
        nzLg="24"
        nzXl="24"
        class="blksMrgn"
      >
        <div class="inptLbl">Sachivalayam Name</div>
        <nz-select
          nzShowSearch
          nzAllowClear
          style="width: 100%"
          nzPlaceHolder="Select Sachivalayam"
          formControlName="svm_id"
          (ngModelChange)="getcluster()"
        >
          @for (s of schvlymlst; track s) {
          <nz-option [nzValue]="s.svm_id" [nzLabel]="s.svm_nm"> </nz-option>
          }
        </nz-select>
      </div>
    </div>
    <div class="input-row" nz-row>
      <div
        nz-col
        nzXs="24"
        nzSm="24"
        nzMd="24"
        nzLg="24"
        nzXl="24"
        class="blksMrgn"
      >
        <div class="inptLbl">Cluster Name</div>
        <nz-select
          nzShowSearch
          nzAllowClear
          style="width: 100%"
          nzPlaceHolder="Select Cluster"
          formControlName="tu_id"
          (ngModelChange)="getvlntr()"
        >
          @for (c of clusterlst; track c) {
          <nz-option [nzValue]="c.tu_id" [nzLabel]="c.tu_nm"> </nz-option>
          }
        </nz-select>
      </div>
      <div
        nz-col
        nzXs="24"
        nzSm="24"
        nzMd="24"
        nzLg="24"
        nzXl="24"
        class="blksMrgn"
      >
        <div class="inptLbl">Volunteer Name</div>
        <nz-select
          nzShowSearch
          nzAllowClear
          style="width: 100%"
          nzPlaceHolder="Select Volunteer Name"
          formControlName="vlntr_id"
          (ngModelChange)="getvlntr()"
        >
          @for (v of vlntrlst; track v) {
          <nz-option [nzValue]="v.vlntr_id" [nzLabel]="v.vlntr_nm"> </nz-option>
          }
        </nz-select>
      </div>
    </div>
    @if (shwalert == true) {
    <div nz-row style="margin-top: 10px" class="blksMrgn">
      <nz-alert
        [nzCloseable]="true"
        nzType="error"
        nzMessage="This Volunteer is already assigned. Please choose another Volunteer"
      ></nz-alert>
    </div>
    } @if (shwblckEditDiv==false && shwblckDelDiv==false) {
    <button nz-button nzType="primary" class="sbmtBtm" (click)="saveblock()">
      Submit
    </button>
    } @if (shwblckEditDiv==true && shwblckDelDiv==false) {
    <button
      nz-button
      nzType="primary"
      class="sbmtBtm"
      (click)="saveEditblock()"
    >
      Update
    </button>
    } @if (shwblckEditDiv==false && shwblckDelDiv==true) {
    <button
      nz-button
      nzType="primary"
      class="sbmtBtm"
      nz-popconfirm
      nzPopconfirmTitle="Are you sure delete this volunteer?"
      nzPopconfirmPlacement="bottom"
      [nzIcon]="iconTpl"
      nzOkText="YES"
      nzCancelText="NO"
      (nzOnConfirm)="saveDeleteblock()"
      (nzOnCancel)="cancel()"
    >
      Delete
    </button>
    }
    <button nz-button nzType="default" class="cnclBtn" (click)="cancelbtn()">
      Cancel
    </button>
    <ng-template #iconTpl>
      <i nz-icon nzType="question-circle-o" style="color: red"></i>
    </ng-template>
  </form>
</nz-drawer>
